"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BoxUi = function BoxUi(_ref) {
  var containerProps = _ref.containerProps,
      align = _ref.align,
      alignItems = _ref.alignItems,
      color = _ref.color,
      bg = _ref.bg,
      bgImage = _ref.bgImage,
      display = _ref.display,
      fontFamily = _ref.fontFamily,
      fontWeight = _ref.fontWeight,
      float = _ref.float,
      justifyContent = _ref.justifyContent,
      clearfix = _ref.clearfix,
      fullWidth = _ref.fullWidth,
      mt = _ref.mt,
      ml = _ref.ml,
      mr = _ref.mr,
      mb = _ref.mb,
      pt = _ref.pt,
      pl = _ref.pl,
      pr = _ref.pr,
      pb = _ref.pb,
      as = _ref.as,
      children = _ref.children,
      id = _ref.id;
  return /*#__PURE__*/_react.default.createElement(_uiKit.Box, _objectSpread(_objectSpread({}, containerProps), {}, {
    // kit styles
    align: align,
    alignItems: alignItems,
    color: color,
    bg: bg,
    bgImage: bgImage,
    display: display,
    fontFamily: fontFamily,
    fontWeight: fontWeight,
    float: float,
    justifyContent: justifyContent,
    clearfix: clearfix,
    fullWidth: fullWidth,
    mt: mt,
    ml: ml,
    mr: mr,
    mb: mb,
    pt: pt,
    pl: pl,
    pr: pr,
    pb: pb,
    as: as,
    children: children,
    id: id
  }));
};

var _default = BoxUi;
exports.default = _default;